export default "__VITE_ASSET__Cz4bbQjw__"